import React  from 'react';
import {setLoadingStateDispatch, useLoadingDispatcher} from "../../context/LoadingContext";
import {setSnackbarDispatch, SnackbarActionTypes, useSnackbarDispatcher} from "../../context/SnackBarContext";
import {useAuthState} from "../../context/AuthContext";
import {useEffect, useState} from "react";
import {Box, Button, Typography} from "@material-ui/core";
import CustomTable from "../../component/customTable/CustomTable";
import {Pagination} from "@material-ui/lab";
import TagInformation from "./TagInformation";
import {TagService} from "./TagService";

let selectedItemId = -1
const TagManagerList = () => {
    let page = 0

    const loading = useLoadingDispatcher()
    const snackbar = useSnackbarDispatcher()
    const {token, fundID} = useAuthState()

    const service = new TagService(fundID, token, snackbar, loading)


    useEffect(() => {
        if (typeof service !== 'undefined') {
            getListDataFromServer()
        }
    }, [])


    const [openModal, setOpenModal] = useState(false)

    const handleClickOpen = () => {
        setOpenModal(true)
    }
    const handleClose = () => {
        setOpenModal(false)
        selectedItemId = -1

        if (needRefresh) {
            getListDataFromServer()
        }
    }


    const [pageCount, setPageCount] = useState(1);
    const [itemCount, setItemCount] = useState(5);

    const [costsAndRevenuesList, setCostsAndRevenuesList] = useState([]);

    const [needRefresh, setNeedRefresh] = useState(false);

    const handleChange = (event, value) => {
        page = value - 1
        getListDataFromServer()
    };

    function getListDataFromServer() {
        loading(setLoadingStateDispatch(true))

        service.getTags(
            page
        ).then(response => {

            setResponseData(response)

            loading(setLoadingStateDispatch(false))
        }).catch(reason => {

            snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, "خطا در دریافت لیست تگ ها"))
            loading(setLoadingStateDispatch(false))
        })
    }

    function setResponseData(responseData) {
        setItemCount(responseData.numberOfItems)
        setPageCount(responseData.totalPage)
        setCostsAndRevenuesList([])

        responseData.data.map((item, index) => {
            setCostsAndRevenuesList(prevState => [...prevState,
                prepareGroupsJsonList(
                    item.id,
                    (page * 10) + index + 1,
                    item.name,
                    item.createdBy,
                )
            ])
        })
    }

    function prepareGroupsJsonList(id, number, name, createdBy) {
        return {
            id,
            number,
            name,
            createdBy
        }
    }

    const showEventsContent = (rowId) => {
        selectedItemId = rowId
        handleClickOpen();
    }

    return (
        <>
            {
                <TagInformation
                    handleClose={handleClose}
                    openModal={openModal}
                    tagId={selectedItemId}
                    changeNeedRefreshState={setNeedRefresh}
                />
            }
            <section className='pageContainer' style={{overflowY: 'hidden'}}>

                <Box className="d-flex flex-row w-100"
                     sx={{
                         margin: '1rem 0 1.2rem 0',
                         justifyContent: 'center',
                         alignContent: 'center',
                         alignItems: 'center'
                     }}>
                    <section className='d-flex flex-column flex-nowrap flex-grow-1'
                             style={{alignItems: 'baseline'}}>
                        <Typography variant={"h5"}>
                            تگ ها
                        </Typography>
                        {itemCount > 0 ?
                            <Typography style={{margin: "8px 8px 0 8px"}} variant={"caption"}>
                                {" " + itemCount + " تگ ثبت شده "}
                            </Typography> :
                            ''}
                    </section>
                    <Button
                        variant='contained'
                        onClick={() => {
                            selectedItemId = -1
                            handleClickOpen();
                        }}
                    >
                        افزودن تگ جدید
                    </Button>
                </Box>

                <CustomTable
                    header={tagsListHeaders}
                    data={costsAndRevenuesList}
                    rowClicked={showEventsContent}
                />
                <Box className="paginationContainer">
                    <Pagination
                        count={pageCount}
                        color="primary"
                        onChange={handleChange}
                        showFirstButton showLastButton/>
                </Box>
            </section>
        </>
    )
}

export default TagManagerList;


const tagsListHeaders = [
    {
        id: 'number',
        label: '#',
        align: 'right',
    },
    {
        id: 'name',
        label: 'عنوان',
        align: 'right',
    },
    {
        id: 'createdBy',
        label: 'سازنده',
        align: 'right',
    },
];
